/**
 * Training admin client — extends trainingApi.js with admin-only endpoints.
 */
import axios from "axios";
import { API } from "@/App";

function hdr() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function getAdminSettings() {
  const r = await axios.get(`${API}/training/admin/settings`, { headers: hdr() });
  return r.data;
}

export async function patchAdminSettings(payload) {
  const r = await axios.patch(`${API}/training/admin/settings`, payload, { headers: hdr() });
  return r.data;
}

export async function getAdminTopics() {
  const r = await axios.get(`${API}/training/admin/topics`, { headers: hdr() });
  return r.data;
}

export async function getAdminUserProgress() {
  const r = await axios.get(`${API}/training/admin/user-progress`, { headers: hdr() });
  return r.data;
}

export async function getAdminAnalytics() {
  const r = await axios.get(`${API}/training/admin/analytics`, { headers: hdr() });
  return r.data;
}

export async function createAdminTopic(payload) {
  const r = await axios.post(`${API}/training/admin/topics`, payload, { headers: hdr() });
  return r.data;
}

export async function updateAdminTopic(slug, payload) {
  const r = await axios.patch(`${API}/training/admin/topics/${encodeURIComponent(slug)}`, payload, { headers: hdr() });
  return r.data;
}

export async function deleteAdminTopic(slug) {
  const r = await axios.delete(`${API}/training/admin/topics/${encodeURIComponent(slug)}`, { headers: hdr() });
  return r.data;
}
